import ShippingType from "./ShippingTypeContainer";
export default ShippingType;
